module.exports = __webpack_public_path__ + "static/media/occ.3e3d46de.png";